"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExempleItem = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_bootstrap_1 = require("react-bootstrap");
const types_1 = require("./types");
const SankeyUtils_1 = require("./SankeyUtils");
/**
 * Description placeholder
 *
 * @type {*}
 */
const ExempleMenuDictTypes = prop_types_1.default.objectOf(prop_types_1.default.element.isRequired).isRequired;
/**
 * Description placeholder
 *
 * @type {{ exemple_menu: any; url_prefix: any; data: any; set_data: any; current_path: any; multi_selected_nodes: any; multi_selected_links: any; multi_selected_label: any; launch: any; }}
 */
const ExempleItemPropTypes = {
    exemple_menu: prop_types_1.default.oneOf([prop_types_1.default.element.isRequired, ExempleMenuDictTypes]).isRequired,
    url_prefix: prop_types_1.default.string.isRequired,
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    current_path: prop_types_1.default.string.isRequired,
    multi_selected_nodes: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyNodePropTypes).isRequired).isRequired }).isRequired,
    multi_selected_links: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyLinkPropTypes).isRequired).isRequired }).isRequired,
    launch: prop_types_1.default.func.isRequired,
    reinitialization: prop_types_1.default.func.isRequired,
    set_user_scale: prop_types_1.default.func.isRequired
};
/**
 * Description placeholder
 *
 * @param {ExempleItemTypes} { exemple_menu, url_prefix, data, set_data, current_path, multi_selected_nodes, multi_selected_links,multi_selected_label,launch}
 * @returns {*}
 */
const ExempleItem = ({ exemple_menu, url_prefix, data, set_data, current_path, multi_selected_nodes, multi_selected_links, launch, reinitialization, set_user_scale }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, ('Files' in exemple_menu)
        ? exemple_menu['Files'].map((item, index) => {
            let path = current_path + '/sankey/' + item;
            if (!item.includes('.xlsx') && !item.includes('.json')) {
                let url = window.location.origin + '/fm/userfiles/' + current_path + '/' + item;
                let suffix = 'ZIP';
                if (!item.includes('zip')) {
                    url = url + '/index.html';
                    suffix = 'HTML';
                }
                return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: index, href: url, target: "_blank" }, current_path.split('/').slice(0, -1).pop() + ' ' + suffix));
            }
            if (item.includes('.xlsx')) {
                path = current_path + '/' + item;
            }
            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: index, onClick: () => {
                    multi_selected_nodes.current = [];
                    multi_selected_links.current = [];
                    if (path.includes('xlsx')) {
                        launch(path, url_prefix);
                    }
                    SankeyUtils_1.uploadExemple(path, url_prefix, data, set_data, reinitialization, set_user_scale);
                } }, item.includes('xlsx') ? item.includes('reconciled') ? item.split('.x')[0].replace(/_/g, ' ').replace('reconciled', ' excel') : item.split('.x')[0].replace(/_/g, ' ') + ' excel'
                : item.includes('json') ? item.replace(/_/g, ' ').replace(' layout.json', ' sankey') : item.replace('afmsankey_0.9.0.', '')));
        }) : Object.keys(exemple_menu).map((key, index) => {
        const tmp_title = key.replaceAll('_', '__').split('__');
        if (tmp_title.length > 1) {
            tmp_title.shift();
        }
        const title = tmp_title.join(' ');
        if (key === 'artefacts') {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        if (key == 'Tests') {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        let the_current_path = current_path;
        if (!key.includes('OpenSankey')) {
            the_current_path = current_path !== '' ? current_path + '/' + key.replace('Sankey', '').replace('Excel', '') : key.replace('Sankey', '').replace('Excel', '');
        }
        else {
            the_current_path = current_path !== '' ? current_path + '/' + key : key;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.NavDropdown, { drop: 'end', key: index, title: title, id: key },
                react_1.default.createElement(exports.ExempleItem, { exemple_menu: exemple_menu[key], url_prefix: url_prefix, data: data, set_data: set_data, current_path: the_current_path, multi_selected_links: multi_selected_links, multi_selected_nodes: multi_selected_nodes, launch: launch, reinitialization: reinitialization, set_user_scale: set_user_scale }))));
    })));
};
exports.ExempleItem = ExempleItem;
exports.ExempleItem.propTypes = ExempleItemPropTypes;
exports.default = exports.ExempleItem;
